<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="VATPeriods"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <DIV
    class="overflow-auto h-100 p-3"
  >
    <ItpDataTable
      tableId="Settings.VATPeriods"
      editable
      :isRowEditable="p => !p.locked"
      :value="items"
      :columns="b_8564662037462133_columns"
      class="h-100"
      ref="table"
      v-if="loaded"
      @save="evh_8564662037462133_save($event, {})"
      @delete="evh_8564662037462133_delete($event, {})"
    >
    </ItpDataTable>
  </DIV>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "settings.vatPeriods",
    path: "vat-periods",
    component: "VATPeriods"
  }
)

@Component()
export default class VATPeriods extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_vat_periods')
  }

  frequencyOptions!: any;

  async $$load_frequencyOptions() {
    return this.$app.repo.get('ui_metadata', { path: 'vat_frequency_options' })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_8564662037462133_columns!: any;

  async $$load_b_8564662037462133_columns() {
    return [{
      name: "name",
      header: this.$fn.pgettext("VATPeriod", "Name"),
      width: "160px",
      required: true,
    }
      ,
    {
      name: "frequency",
      header: this.$fn.pgettext("VATPeriod", "Frequency"),
      type: "select",
      options: this.frequencyOptions,
      valueField: "value",
      textField: "name",
      width: "140px",
      required: true,
    }
      ,
    {
      name: "start",
      header: this.$fn.pgettext("VATPeriod", "Start"),
      width: "160px",
      type: "date",
      required: true,
    }
      ,
    {
      name: "end",
      header: this.$fn.pgettext("VATPeriod", "End"),
      width: "160px",
      type: "date",
      required: true,
    }
      ,
    {
      name: "due_date",
      header: this.$fn.pgettext("VATPeriod", "Due date"),
      width: "160px",
      type: "date",
      required: true,
    }
      ,
    {
      name: "closed",
      header: this.$fn.pgettext("VATPeriod", "Closed"),
      type: "checkbox",
    }
      ,
    ]
  }

  dataMembers = ['items', 'frequencyOptions', 'ux', 'b_7315092382398562_modalBindings', 'b_8564662037462133_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        frequencyOptions: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_8564662037462133_columns: null,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return
    }
    return null;
  }

  async act_7315092382398562_closeModal_5622_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5622, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_script_5624_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_8564662037462133_script_5624, alias=undefined
    $event.data.waitFor(this.$fn.crud('vat_period').upsert({ ...$event.data.row }))
  }

  async act_8564662037462133_script_5624_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_8564662037462133_script_5624, alias=undefined
    return {
      value: () => this.act_8564662037462133_script_5624_getActionArgs_value($event),
    }
  }

  async evh_8564662037462133_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_save.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_script_5626_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_8564662037462133_script_5626, alias=undefined
    $event.data.waitFor(this.$fn.crud('vat_period').delete({ ...$event.data.row }))
  }

  async act_8564662037462133_script_5626_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_8564662037462133_script_5626, alias=undefined
    return {
      value: () => this.act_8564662037462133_script_5626_getActionArgs_value($event),
    }
  }

  async evh_8564662037462133_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_delete.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5622: actions.CloseModalAction;
    evh_7315092382398562_close_5621: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_8564662037462133_script_5624: actions.ScriptAction;
    evh_8564662037462133_save_5623: actions.EventHandlerImpl;
    evh_8564662037462133_save: actions.EventHandlerGroup;
    act_8564662037462133_script_5626: actions.ScriptAction;
    evh_8564662037462133_delete_5625: actions.EventHandlerImpl;
    evh_8564662037462133_delete: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5622 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5622_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5621 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5622,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5621],
      }
    );
    const act_8564662037462133_script_5624 = new actions.ScriptAction(
      {
        actionArgs: this.act_8564662037462133_script_5624_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_save_5623 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_script_5624,
        event: "save",
        displayName: "script",
      }
    );
    const evh_8564662037462133_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_save_5623],
      }
    );
    const act_8564662037462133_script_5626 = new actions.ScriptAction(
      {
        actionArgs: this.act_8564662037462133_script_5626_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_delete_5625 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_script_5626,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_8564662037462133_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_delete_5625],
      }
    );
    return {
      act_7315092382398562_closeModal_5622,
      evh_7315092382398562_close_5621,
      evh_7315092382398562_close,
      act_8564662037462133_script_5624,
      evh_8564662037462133_save_5623,
      evh_8564662037462133_save,
      act_8564662037462133_script_5626,
      evh_8564662037462133_delete_5625,
      evh_8564662037462133_delete,
    }
  }
}

Vue.component("VATPeriods", VATPeriods);

</script>